import { useLingui } from "@lingui/react/macro";
import useSWRMutation from "swr/mutation";

import { useRelatedPokeList } from "~/hook/domain/useRelatedPokeList.ts";
import { useUserPofile } from "~/hook/domain/useUserProfile.ts";
import { useUserRelatedPokeList } from "~/hook/domain/useUserRelatedPokeList.ts";
import { useUser } from "~/ui/provider/Auth.tsx";
import { useNotification } from "~/ui/provider/Notification.tsx";

export const useUserRelation = (targetUserEmail: string, close: () => void) => {
  const { t } = useLingui();
  const push = useNotification();

  const { client, refreshUser } = useUser();

  const { mutate: mutateRelatedPokes } = useRelatedPokeList();
  const { mutate: mutateUser } = useUserPofile(targetUserEmail);
  const { mutate: mutateUserPoke } = useUserRelatedPokeList(targetUserEmail);

  const mutateAll = () =>
    Promise.allSettled([
      refreshUser(),
      mutateRelatedPokes(),
      mutateUser(),
      mutateUserPoke(),
    ]);

  const { trigger: triggerBlock } = useSWRMutation(
    `relation/${targetUserEmail}`,
    (api) =>
      client
        .patch(api, { json: { isAccepted: false } })
        .then(() => mutateAll())
        .then(() => {
          push({ content: t`사용자를 차단했습니다.` });
          close();
        }),
    {
      onError: () => {
        push({ content: t`다시 시도해주세요.` });
      },
    },
  );

  const { trigger: triggerUnfollow } = useSWRMutation(
    `relation/${targetUserEmail}`,
    (api) =>
      client
        .patch(api, { json: { isFollowing: false } })
        .then(() => mutateAll())
        .then(() => {
          push({
            content: t`사용자를 팔로우 취소했습니다.`,
          });
          close();
        }),
    {
      onError: () => {
        push({ content: t`다시 시도해주세요.` });
      },
    },
  );

  const handleBlock = async () => {
    await triggerBlock();
  };

  const handleUnfollow = async () => {
    await triggerUnfollow();
  };

  return {
    handleBlock,
    handleUnfollow,
  };
};
